import { render, staticRenderFns } from "./button-tooltip.vue?vue&type=template&id=3a1791d1&lang=pug&"
import script from "./button-tooltip.vue?vue&type=script&lang=ts&"
export * from "./button-tooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports